


















































































































import {
    EventBus,
    TypeEventBus,
    getUniqueId,
    addItemsToListIfAreNotAdded,
    removeItemsFromList
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { MultipleSelect, MsgBox } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import multiselect from 'vue-multiselect';
import Sortable from 'sortablejs';
import ConfirmAction from '../../core/components/ConfirmAction.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import { phoneValidator } from '../../core/utils/validations';
import Input from '../../core/components/Input.vue'
import Checkbox from '../../core/components/Checkbox.vue'
import InfoIcon from '../../core/components/InfoIcon.vue'
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { NormsServices } from '../../norms/api/NormsServices';
import InputPhone from '../../core/components/InputPhone.vue';

@Component({
    components: { 
        MultipleSelect, 
        MsgBox, 
        TableArrows, 
        SimpleTable, 
        multiselect, 
        ConfirmAction, 
        SectionTitle, 
        Input,
        Checkbox,
        InfoIcon,
        InputPhone
    }
})
export default class PhoneNumber extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({ default: [] }) serviceProviderList: Array<object>;

    phoneValidation: any = phoneValidator;
    phoneNumberValidate: any = this.checkPhoneNumber;

    serviceProvider: any = {};

    modalWidth: string = '600';
    visibleDeleteConfirmAction: boolean = false;

    selectedVariables: any = [];

    phoneNumber: string = '';
    iccid: string = '';
    description: string = '';

    selectedUnit: any = {};

    definitiveListInExcel: boolean = false;

    processingRequest: boolean = false;
    absolute: boolean = false;

    updateDefinitiveListInExcel(value){
       this.definitiveListInExcel = value;
    }
    updatePhoneNumber(value){
        this.phoneNumber = value;
        this.sendDataToParent();
    }
    updateIccid(value){
        this.iccid = value;
        this.sendDataToParent();
    }

    checkPhoneNumber(value){
        return phoneValidator(value, true)
    }

    submitPhone() {
        this.sendDataToParent();
        this.$emit('submitPhone');
    }

    get canSaveVariableGroup() {
        return Boolean(
            this.serviceProvider.value != undefined &&
                !this.phoneValidation(this.phoneNumber).length &&
                !this.phoneValidation(this.iccid).length
        );
    }

    get input() {
        return this.$refs.input as HTMLInputElement;
    }

    sendDataToParent() {
        if (this.canSaveVariableGroup) {
            let submitedData = {
                phoneNumber: this.phoneNumber,
                iccid: this.iccid,
                serviceProvider: this.serviceProvider.value
            };
            this.$emit('submit', submitedData);
        }
    }

    closeDeleteConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.selectFile();
            // ACA VA EL CODIGO PARA PONERLE LA FLAG AL WEB SERVICE DE CHANGE
            this.absolute = true;
        }
        this.visibleDeleteConfirmAction = false;
    }

    handleSelectFileAction() {
        if (this.definitiveListInExcel) {
            this.visibleDeleteConfirmAction = true;
        } else {
            this.selectFile();
        }
    }

    selectFile() {
        this.input.click();
    }

    onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
            return;
        }

        if (files[0].name.split('.').pop() != 'csv') {
            this.$_showHistoricalError('El archivo debe ser de tipo CSV')
            return;
        }

        let data = {
            file: files[0],
            absolute: this.absolute
        };
        this.$emit('ImportExcel', data);
    }

    @Emit()
    closeDialog(action: boolean, variableGroup: any) {}
}
